module.exports = __webpack_public_path__ + "static/media/step5-completed-mobile.dea66850.svg";